import axios from "axios";

const saveUserEvents = async (event, data, token) => {
  if (event !== "newMessageTelegram") {
    try {
      if (token) {
        axios.defaults.headers.common.Authorization = token;
      }
      const payload = data
        ? {
            front: "classic",
            ...data,
          }
        : { front: "classic" };
      const version = process.env.REACT_APP_VERSION;
      const timestamp = new Date();
      const body = {
        event,
        payload,
        version,
        timestamp,
      };
      await axios.post(`/user/events`, body);
    } catch (error) {
      console.log("Error on save log", error);
    }
  }
};

export default saveUserEvents;
